import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import moment from 'moment'
import { formatByTimeZone } from 'utils'

class Dateprogress extends Component {
	state = {
		hasMounted: false
	}

	componentDidMount = _ => {
		setTimeout(_ => {
			this.setState({
				hasMounted: true
			})
		},1)
	}

	render() {
		const {
			percent,
			startDate,
			endDate
		} = this.props

		const {
			hasMounted
		} = this.state

		let formattedStartDate = null
		let formattedEndDate = null

		if(!percent){
			let now = moment();
			let startMoment = moment(startDate);
			let endMoment = moment(endDate);
			let percentage_complete = (now - startMoment) / (endMoment - startMoment) * 100;

			if(startDate && endDate){
				this.percentage_rounded = (Math.round(percentage_complete * 100) / 100); 
			}else{
				this.percentage_rounded = 0;
			}

			formattedStartDate = startDate ? formatByTimeZone(startMoment,'MMMM Do') : ('No start date')
			formattedEndDate = endDate ? formatByTimeZone(endMoment,'MMMM Do') : ('No end date')
		}else{
			this.percentage_rounded = percent
		}

		return (
			<div className="dateprogress-container">
				{ !percent && 
					<Icon name="fe-calendar" />
				}
				{ !percent &&
					<span>
						{ formattedStartDate }
					</span>
				}
				<div className="dateprogress-bar">
					<div style={{width: hasMounted ? this.percentage_rounded+"%" : 0+'%'}}></div>
				</div>
				{ !percent &&
					<span>
						{ formattedEndDate }
					</span>
				}
			</div>
		);
	}
}

export default Dateprogress;  



// WEBPACK FOOTER //
// ./src/components/date-progress/date-progress.jsx